<div class="mb-1 border-solid border-b border-gray-300 bg-gray-100">
  <span class="text-gray-900 p-3 block text-md font-normal">{{field.name}}</span>
</div>

<div class="p-3" [ngSwitch]="selectedIndex">

  <div *ngSwitchCase="0" class="details-list">
    <div title="Nom" class="head">Nom</div>
    <div>{{field.name}}</div>
  </div>
</div>

<div class="border-t border-gray-300 border-solid">
  <dx-tabs
    [dataSource]="tabs"
    [(selectedIndex)]="selectedIndex"
    (onItemClick)="selectTab($event)"
    [scrollByContent]="true"
    [showNavButtons]="true"
  ></dx-tabs>
</div>
